module.exports = __webpack_public_path__ + "static/media/IMG_7295-min.de16be40.jpg";